import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { MathBackground } from '../components/MathBackground';
import { useLanguage } from '../lib/LanguageContext';
import { translations } from '../lib/translations';
export function IndustryPage() {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].industry;
  return <div style={{
    backgroundColor: 'var(--black)',
    minHeight: '100vh'
  }} data-id="element-484">
      <Navigation data-id="element-485" />

      {/* Page Header */}
      <section style={{
      position: 'relative',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'flex-end',
      overflow: 'hidden',
      paddingBottom: '6rem',
      paddingTop: '64px'
    }} data-id="element-486">
        <MathBackground data-id="element-487" />
        <div style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: '64rem',
        margin: '0 auto',
        padding: '0 2rem',
        width: '100%'
      }} data-id="element-488">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6
        }} style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.75rem',
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'var(--grey-500)',
          marginBottom: '2rem'
        }} data-id="element-489">
            {t.sectorLabel}
          </motion.p>
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 900,
          fontSize: 'clamp(40px, 7vw, 100px)',
          lineHeight: 1,
          letterSpacing: '-0.02em',
          color: 'var(--white)',
          margin: 0
        }} data-id="element-490">
            {t.hero}
          </motion.h1>
        </div>
      </section>

      {/* Sectors */}
      <section style={{
      backgroundColor: 'var(--white)',
      padding: '8rem 0'
    }} data-id="element-491">
        <div style={{
        maxWidth: '64rem',
        margin: '0 auto',
        padding: '0 2rem'
      }} data-id="element-492">
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.75rem',
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'var(--grey-500)',
          marginBottom: '5rem'
        }} data-id="element-493">
            {t.whereLabel}
          </motion.p>

          <div style={{
          display: 'flex',
          flexDirection: 'column'
        }} data-id="element-494">
            {t.sectors.map((sector, i) => <motion.div key={sector.code} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.7,
            delay: i * 0.1
          }} style={{
            borderTop: '1px solid var(--grey-300)',
            padding: '4rem 0',
            display: 'grid',
            gridTemplateColumns: '100px 1fr',
            gap: '3rem',
            alignItems: 'start'
          }} data-id="element-495">
                <span style={{
              fontFamily: '"IBM Plex Mono", monospace',
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              color: 'var(--grey-500)',
              textTransform: 'uppercase',
              paddingTop: '0.4rem'
            }} data-id="element-496">
                  {sector.code}
                </span>
                <div data-id="element-497">
                  <h2 style={{
                fontFamily: '"IBM Plex Sans", sans-serif',
                fontWeight: 700,
                fontSize: 'clamp(1.25rem, 2.5vw, 1.75rem)',
                color: 'var(--black)',
                marginBottom: '1.25rem',
                lineHeight: 1.2
              }} data-id="element-498">
                    {sector.title}
                  </h2>
                  <p style={{
                fontFamily: '"IBM Plex Sans", sans-serif',
                fontWeight: 300,
                fontSize: '1.0625rem',
                color: 'var(--grey-700)',
                lineHeight: 1.8,
                maxWidth: '38rem',
                marginBottom: '1.5rem'
              }} data-id="element-499">
                    {sector.body}
                  </p>
                  <span style={{
                fontFamily: '"IBM Plex Mono", monospace',
                fontSize: '0.7rem',
                letterSpacing: '0.15em',
                color: 'var(--red)',
                textTransform: 'uppercase'
              }} data-id="element-500">
                    {sector.requirement}
                  </span>
                </div>
              </motion.div>)}
            <div style={{
            borderTop: '1px solid var(--grey-300)'
          }} data-id="element-501" />
          </div>
        </div>
      </section>
    </div>;
}